import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import React from 'react';

interface OwnProps {
  text: string;
  icon?: React.ReactNode;
  href?: string;
}

const FeatureListItem: React.FC<OwnProps> = (props) => {
  if (props.href) {
    return (
      <ListItem>
        <ListItemButton component="a" href={props.href} sx={{ padding: 1 }}>
          {props.icon && <ListItemIcon>{props.icon}</ListItemIcon>}
          <ListItemText>{props.text}</ListItemText>
        </ListItemButton>
      </ListItem>
    );
  } else {
    return (
      <ListItem>
        {props.icon && <ListItemIcon>{props.icon}</ListItemIcon>}
        <ListItemText>{props.text}</ListItemText>
      </ListItem>
    );
  }
};

export default FeatureListItem;
